module.exports = __webpack_public_path__ + "static/outside-dispenser-2-ee5ade028ed72fc83f626edd68fe1912.jpg";